/* ==========================================================================
   LURETROPHY Shopify theme — interactions
   ========================================================================== */

(function () {
  "use strict";

  const routes = (window.ltConfig && window.ltConfig.routes) || {};

  function ajaxUrl(path) {
    return path.replace(/\/?$/, ".js");
  }

  /* ---------- Scroll reveal ---------- */
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
  );
  document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

  /* ---------- Header shadow ---------- */
  const header = document.getElementById("siteHeader");
  if (header) {
    window.addEventListener("scroll", () => {
      header.style.boxShadow =
        window.scrollY > 40 ? "0 8px 30px rgba(0,0,0,0.35)" : "none";
    });
  }

  /* ---------- Mobile menu ---------- */
  const menuBtn = document.getElementById("menuBtn");
  const navLinks = document.getElementById("navLinks");
  if (menuBtn && navLinks) {
    menuBtn.addEventListener("click", () => navLinks.classList.toggle("open"));
    navLinks.querySelectorAll("a").forEach((a) =>
      a.addEventListener("click", () => navLinks.classList.remove("open"))
    );
  }

  /* ---------- Product showcase tabs ---------- */
  const tabs = document.querySelectorAll("#productTabs .tab");
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      tabs.forEach((t) => t.classList.remove("active"));
      tab.classList.add("active");
      document.querySelectorAll(".product-panel").forEach((panel) => {
        panel.classList.toggle("active", panel.id === tab.dataset.target);
      });
    });
  });

  /* ---------- Cart drawer ---------- */
  const drawer = document.getElementById("cartDrawer");
  const overlay = document.getElementById("drawerOverlay");
  const cartBtn = document.getElementById("cartBtn");
  const drawerClose = document.getElementById("drawerClose");
  const drawerItems = document.getElementById("drawerItems");
  const drawerTotal = document.getElementById("drawerTotal");
  const drawerCheckout = document.getElementById("drawerCheckout");
  const cartCount = document.getElementById("cartCount");
  const drawerEmpty = document.querySelector(".drawer-empty");

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    if (overlay) overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    if (overlay) overlay.classList.remove("open");
    document.body.style.overflow = "";
  }

  if (cartBtn) cartBtn.addEventListener("click", () => { refreshCart().then(openDrawer); });
  if (drawerClose) drawerClose.addEventListener("click", closeDrawer);
  if (overlay) overlay.addEventListener("click", closeDrawer);
  if (drawerCheckout) {
    drawerCheckout.addEventListener("click", () => {
      window.location.href = "/checkout";
    });
  }

  function money(value) {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD",
      minimumFractionDigits: 2,
    }).format(value / 100);
  }

  async function refreshCart() {
    try {
      const res = await fetch(ajaxUrl(routes.cart || "/cart"));
      const cart = await res.json();
      renderDrawer(cart);
      if (cartCount) cartCount.textContent = cart.item_count;
      return cart;
    } catch (e) {
      return null;
    }
  }

  function renderDrawer(cart) {
    if (!drawerItems || !drawerTotal) return;
    if (!cart.items || !cart.items.length) {
      drawerItems.innerHTML = "";
      if (drawerEmpty) drawerEmpty.style.display = "block";
      drawerTotal.textContent = money(0);
      return;
    }
    if (drawerEmpty) drawerEmpty.style.display = "none";
    drawerItems.innerHTML = cart.items
      .map((item) => {
        const img = item.featured_image && item.featured_image.url
          ? `<img src="${item.featured_image.url}" alt="${item.title}" width="64" height="64">`
          : `<div class="drawer-item-img-placeholder"></div>`;
        return `
          <li class="drawer-item" data-key="${item.key}">
            ${img}
            <div class="drawer-item-info">
              <strong>${item.title}</strong>
              <span>${money(item.price)}</span>
              <div class="qty-control">
                <button class="qty-dec" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
                <span>${item.quantity}</span>
                <button class="qty-inc" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
              </div>
            </div>
            <button class="remove" data-key="${item.key}" data-qty="0" aria-label="Remove">✕</button>
          </li>`;
      })
      .join("");
    drawerTotal.textContent = money(cart.total_price);
  }

  async function changeCart(key, quantity) {
    const body = new FormData();
    body.append("id", key);
    body.append("quantity", String(quantity));
    try {
      await fetch(ajaxUrl(routes.cartChange || "/cart/change"), { method: "POST", body });
      await refreshCart();
    } catch (e) {
      /* keep previous state */
    }
  }

  if (drawerItems) {
    drawerItems.addEventListener("click", (e) => {
      const btn = e.target.closest("button[data-key]");
      if (!btn) return;
      changeCart(btn.dataset.key, Number(btn.dataset.qty));
    });
  }

  /* ---------- Add to cart ---------- */
  async function addToCart(variantId, quantity) {
    const body = new FormData();
    body.append("id", String(variantId));
    body.append("quantity", String(quantity || 1));
    const res = await fetch(ajaxUrl(routes.cartAdd || "/cart/add"), { method: "POST", body });
    if (!res.ok) throw new Error("add failed");
    const cart = await refreshCart();
    openDrawer();
    return cart;
  }

  function pulseCart() {
    if (!cartBtn) return;
    cartBtn.style.transform = "scale(1.18)";
    setTimeout(() => (cartBtn.style.transform = ""), 180);
  }

  /* Quick add buttons on product cards */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".quick-add[data-variant-id]");
    if (!btn) return;
    btn.disabled = true;
    addToCart(btn.dataset.variantId, 1)
      .then(() => pulseCart())
      .catch(() => (btn.disabled = false));
  });

  /* ---------- Product page ---------- */
  const productForm = document.getElementById("ProductForm");
  const variantSelect = document.getElementById("VariantSelect");
  const priceEl = document.querySelector('[id^="Price-"]');
  const compareEl = document.querySelector('[id^="ComparePrice-"]');
  const productJsonEl = document.querySelector('[id^="ProductJSON-"]');
  const quantityInput = document.getElementById("Quantity");

  if (productJsonEl && variantSelect && priceEl) {
    const variants = JSON.parse(productJsonEl.textContent);

    variantSelect.addEventListener("change", () => {
      const variant = variants.find((v) => String(v.id) === variantSelect.value);
      if (!variant) return;
      priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = "";
        } else {
          compareEl.style.display = "none";
        }
      }
      const submitBtn = productForm && productForm.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? "🛒 Add To Cart" : "Sold Out";
      }
      if (variant.featured_image && typeof Shopify !== "undefined" && Shopify.Image) {
        const imgUrl = Shopify.Image.getSizedImageUrl(variant.featured_image.src, "1024x1024");
        const mainImg = document.querySelector(".gallery-slide.active img");
        if (mainImg) mainImg.src = imgUrl;
      }
    });
  }

  if (productForm) {
    productForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const idInput = productForm.querySelector('input[name="id"]');
      const variantId = variantSelect ? variantSelect.value : (idInput && idInput.value);
      if (!variantId) {
        productForm.submit();
        return;
      }
      const qty = quantityInput ? parseInt(quantityInput.value, 10) : 1;
      addToCart(variantId, qty)
        .then(() => pulseCart())
        .catch(() => productForm.submit());
    });
  }

  /* ---------- Product gallery ---------- */
  const thumbs = document.querySelectorAll(".thumb");
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => {
      thumbs.forEach((t) => t.classList.remove("active"));
      thumb.classList.add("active");
      document.querySelectorAll(".gallery-slide").forEach((slide) => {
        slide.classList.toggle("active", slide.dataset.slide === thumb.dataset.target);
      });
    });
  });

  /* ---------- Collection sort ---------- */
  const sortSelect = document.getElementById("SortBy");
  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      const url = new URL(window.location.href);
      url.searchParams.set("sort_by", sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
